import axios from 'axios'

const getWins = ({ commit, state }, payload) => {
  const config = {
    params: {
      acc_code: payload.acc_code,
      sch_code: payload.sch_code
    }
  }

  //commit('uiControl/RSTATE_LOADING', { message: 'កំពុងផ្ទុកទិនន្ន័យពីម៉ាសុីនមេ...' }, { root: true })
  axios.get('/wins/wash', config)
    .then((response) => {
      if (response.data.res === '1') {
        commit('LOAD_DATA_WINS', response.data)
        //commit('uiControl/RSTATE_SUCCESS', null, { root: true })
        //commit('uiControl/SET_SCHOOL_STATE', response.data.state_code.sta_code, { root: true })
        // commit('uiControl/TAB_STATE_CHANGE', { sTab: 3, vTab: 0 }, { root: true })
      } else if (response.data.res === '0') {
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ពុំមានសាលានេះទេ!' }, { root: true })
      }
    }, (error) => {
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
      //console.log(error)
    })
}

const getWinsReport = ({ commit, state }, payload) => {
  const config = {
    params: {
      b_type: payload.b_type,
      b_code: payload.b_code,
      acc_code: payload.acc_code
    }
  }
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងផ្ទុកទិនន្ន័យពីម៉ាសុីនមេ...' }, { root: true })
  axios.get('/wins/wash/report', config)
    .then((response) => {
      if (payload.b_type === 1) {
        commit('LOAD_DATA_WINS_PRO', response.data)
      } else if (payload.b_type === 2) {
        commit('LOAD_DATA_WINS_DIS', response.data)
      } else if (payload.b_type === 3) {
        commit('LOAD_DATA_WINS_COM', response.data)
      } else if (payload.b_type === 4) {
        commit('LOAD_DATA_WINS_SCH', response.data)
      }
      commit('uiControl/RSTATE_SUCCESS', null, { root: true })
      // commit('uiControl/TAB_STATE_CHANGE', { sTab: 3, vTab: 0 }, { root: true })
    }, (error) => {
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
      //console.log(error)
    })
}
/* ====== Load summary report from backend server ====== */
const getWinsSummaryReport = ({ commit, state }, payload) => {
  const config = {
    params: {
      b_type: payload.b_type,
      b_code: payload.b_code,
      acc_code: payload.acc_code
    }
  }

  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងផ្ទុកទិនន្ន័យពីម៉ាសុីនមេ...' }, { root: true })
  axios.get('/wins/wash/summary', config)
    .then((response) => {
      commit('LOAD_DATA_WINS_SUM', response.data)
      commit('uiControl/RSTATE_SUCCESS', null, { root: true })
      // commit('uiControl/TAB_STATE_CHANGE', { sTab: 3, vTab: 0 }, { root: true })
    }, (error) => {
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
      //console.log(error)
    })
}
/* ====== Requesting the basic report ====== */
const getBasicASCFReport = ({ commit, state }, payload) => {
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងផ្ទុកទិនន្ន័យពីម៉ាសុីនមេ...' }, { root: true })

  const config = {
    responseType: 'blob', // important
    params: {
      pcode: payload.p_code,
      acode: payload.a_code
    }
  }
  // need to replace to docker and nginx link
  // axios.get('https://emiskh.com/REPORTS/baseinfo', config)
  // http://localhost:8888/baseinfo?pcode=04&acode=11
  axios.get('http://localhost:8888/baseinfo', config)
    .then((response) => {
      // commit('LOAD_DATA_WINS_SUM', response.data)
      commit('uiControl/RSTATE_SUCCESS', null, { root: true })
      var fileURL = window.URL.createObjectURL(new Blob([response.data]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', payload.p_code + '_basicInfo.xlsx')
      document.body.appendChild(fileLink)
      fileLink.click()
      // commit('uiControl/TAB_STATE_CHANGE', { sTab: 3, vTab: 0 }, { root: true })
    }, (error) => {
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
    })
}

const loadDefaultWins = ({ commit, state }) => {
  commit('LOAD_DEFAULT_WINS')
  //commit('uiControl/SET_SCHOOL_STATE', 0, { root: true }) // Reset school state to ZERO
}

const saveWins = ({ commit, state }) => {
  var d = state.winsObj
  // console.log(d)
  // prepared data for posting to server
  // DataFormat: id, 26 variables data, 4 star categories, 1 final_star, state
  // DataFormat: final_star_rating_for_school(0 to 3)
  // DataExample: (5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0, 0,0,0,0, 1, 21)
  // let sCode = 21 // SET to 21, will update if data need verification or clean
  let sId = 1 //Just dump data all state integrated with ASCF
  let winsDt = '('
  winsDt += d.wash[0].id + ','
  winsDt += d.wash[0].dt + ','
  winsDt += d.wash[0].star + ','
  winsDt += d.wash[0].final_star_ranking + ')'
  /*
  for (let i = 0; i < d.wash[0].dt.length; i++) {
    winsDt += d.wash[0].dt[i] + ','
  }
  winsDt += '2,' // saving data state always set to value 2
  winsDt += d.wash[0].final_star_ranking + ')'
  */
  // console.log(winsDt)
  // posting to server
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងរក្សាទិនន្ន័យទៅម៉ាសុីនមេ...' }, { root: true })
  axios.post('/wins/wash', { sta_id: sId, wash: winsDt/*, state_code: sCode*/ })
    .then((response) => {
      // console.log(response.data + 'Done')
      if (response.data === 0) {
        commit('uiControl/RSTATE_SAVE_SUCCESS', { message: 'ទិនន្ន័យរក្សាទុកត្រឹមត្រូវក្នុងម៉ាសុីនមេ' }, { root: true })
      } else {
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ ' + response.data }, { root: true })
      }
    }, (error) => {
      // console.log(error)
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
    })
}

const logWins = ({ commit, state }) => {
  //console.log(state.school_dt.sco_g1[0].dt)
}

export {
  loadDefaultWins,
  getWins,
  saveWins,
  getWinsReport,
  getWinsSummaryReport,
  logWins,
  getBasicASCFReport
}
